import CompanyMeasurementsBlock from "../components/blocks/CompanyMeasurementsBlock";

const CompanyMeasurementOverview = () => {

    return (<>
        <CompanyMeasurementsBlock/>
    </>)
}
export default CompanyMeasurementOverview
